module.exports = __webpack_public_path__ + "media/images/logos/google_gmail-41df57109ed99ab2a393cf4aaa8d2aad.svg";